import { Button, message, Modal, Form, Input } from 'antd';
import { useState } from 'react';
import { useStoreBestDeal } from '../hooks/useBestDeals';
import NoImagePlaceholder from "../No-Image.png";
const ProductCard = ({ product }) => {
    const { image_paths, name, left_in_stock, price, id } = product;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const { mutate: storeBestDeal, isLoading } = useStoreBestDeal();

    const handleAddToBestDeals = () => {
        setIsModalVisible(true);
    };

    const handleSubmit = (values) => {
        storeBestDeal({
            product_id: id,
            tag: values.tag,
            description: values.description
        }, {
            onSuccess: () => {
                message.success('Product added to best deals successfully!');
                setIsModalVisible(false);
                form.resetFields();
            },
            onError: () => {
                message.error('Failed to add product to best deals');
            }
        });
    };

    return (
        <div className="group p-4 rounded-xl shadow-lg bg-white flex flex-col h-full transition-all duration-300 hover:shadow-xl">
            <div className="w-full mb-3 relative overflow-hidden rounded-lg aspect-square">
                <img
                    alt={name}
                    src={image_paths? image_paths[0]: NoImagePlaceholder}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute top-2 right-2 bg-white/90 px-3 py-1 rounded-full text-sm font-medium">
                    <span className={left_in_stock > 5 ? "text-green-600" : "text-red-600"}>
                        {left_in_stock} in stock
                    </span>
                </div>
            </div>

            <div className="p-2 flex-grow">
                <h5 className="text-lg font-bold text-gray-800 line-clamp-2 mb-2">{name}</h5>
                <div className="text-xl font-semibold text-yellow-600 mb-4">
                    {price} br
                </div>
            </div>

            <Button
                onClick={handleAddToBestDeals}
                disabled={image_paths?.length === 0 || left_in_stock === 0}
                className={`!text-white !rounded !hover:bg-yellow-600 ${image_paths?.length===0 || left_in_stock===0 ?"!bg-gray-300":"!bg-yellow-500"}`}
                title={left_in_stock>0?image_paths?.length === 0 ?"Add image first before add to best deal":"add to best deals":"out of stock"}
            >
                Add to Best Deals
            </Button>

            <Modal
                title="Add to Best Deals"
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                centered
                className="[&_.ant-modal-content]:!rounded-2xl [&_.ant-modal-content]:!p-6 [&_.ant-modal-header]:!border-0 [&_.ant-modal-title]:!text-xl [&_.ant-modal-title]:!font-bold"
                style={{ maxWidth: '90vw' }}
                getContainer={false}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                >
                    <Form.Item
                        label="Tag"
                        name="tag"
                        rules={[{ required: true, message: 'Please enter a tag' }]}
                        className="mb-6"
                    >
                        <Input
                            placeholder="e.g. Holiday Discount"
                            className="!rounded-lg !py-2 hover:!border-yellow-500 focus:!border-yellow-600 !shadow-sm"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Description"
                        name="description"
                        rules={[{ required: true, message: 'Please enter a description' }]}
                        className="mb-6"
                    >
                        <Input.TextArea
                            rows={4}
                            placeholder="e.g. Use this chance and buy this item"
                            className="!rounded-lg hover:!border-yellow-500 focus:!border-yellow-600 !shadow-sm"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            htmlType="submit"
                            loading={isLoading}
                            block
                            className="!bg-yellow-500 !text-white !rounded-lg !h-10 !font-medium hover:!bg-yellow-600 !border-none !shadow-sm"
                        >
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default ProductCard;